import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {

    public static readonly key = {
        authData: 'auth_data',
        seeHowRole: 'SeeHowRole',
        userToSeeHowManager: 'UserToSeeHowManager',
        selectedAccess: 'SelectedAccess',
        userIdToImpersonate: 'UserIdToImpersonate',
        originalRole: 'OriginalRole',
        impersonatedUser: 'ImpersonatedUser',
        loggedUser: 'loggedUser',
        logoUrl: 'logo-url',
        colorPalette: 'color-palette',
        trackResponsible: 'track-responsible',
        userSelectedLanguage: 'userSelectedLanguage',
        storedTranslation: 'storedTranslation',
        userModuleProgress: 'user-module-progress',
        questionModuleReload: 'questionModuleReload',
        editingModule: 'editingModule',
        automaticSyncRules: 'automatic-sync-rules',
        lastSession: 'lastSession',
        darkMode: 'darkMode',
        scheduleJobs: 'schedule_jobs',
        version: 'performance:version',
		personalChoiceLanguage: 'personalChoiceLanguage',
		loginType: 'loginType',
		returnUrl: 'returnUrl',
        cycleId: 'cycleIdSelected',
    };


    constructor() {
    }

}
